(function () {
	if (typeof AOS === 'undefined') return;

	// Honor users who've asked for less motion — skip the animations entirely.
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function init() {
		AOS.init({
			duration: 600,      // ms
			easing: 'ease-out',
			offset: 80,         // trigger a little before the element is fully in view
			once: true,         // animate the first time only — sections don't re-hide on scroll up
			disable: reduceMotion,
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
